import { InjectionToken } from '@angular/core';
export const API_CONFIG = new InjectionToken<string>('ApiServiceConfig');
